import React from "react";
import { useSelector } from "react-redux";

const UpdatesUnavailable = () => {
  const isGwUp =
    useSelector(state => state.downIndicator?.gwIndicator)?.toLowerCase() ===
    "up";
  return !isGwUp ? (
    <div className="friendly-error-messaging">
      <strong>
        Updates are currently unavailable due to planned maintenance. We
        appreciate your patience!
      </strong>
    </div>
  ) : null;
};

export default UpdatesUnavailable;
